export enum Groupings{
    Single,
    Gangs,
}